import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';



const json = {

  1: { // Exercise num
    unit: 'Unit 7',
    id: 'WB4-V2-U7-P53-E1',
    audio: 'img/FriendsPlus/Page53/Audio/audio-e1-p53.mp3',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page53/E1/Key/answerKey.png',
    component: D1,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page53/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page53/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page53/Audio/tieude-e1-p53.mp3' },
        { url: 'img/FriendsPlus/Page53/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page53/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page53/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page53/E1/6.jpg', input: true, answer: "big animals." },
        { url: 'img/FriendsPlus/Page53/E1/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page53/E1/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page53/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page53/E1/10.jpg', input: true, answer: "lions." },
        { url: 'img/FriendsPlus/Page53/E1/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page53/E1/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page53/E1/13.jpg' },
        { url: 'img/FriendsPlus/Page53/E1/14.jpg', input: true, answer: "eleven lions." },
        { url: 'img/FriendsPlus/Page53/E1/15.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page53/E1/16.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page53/E1/17.jpg' },
        { url: 'img/FriendsPlus/Page53/E1/18.jpg', input: true, answer: "birds." },
        { url: 'img/FriendsPlus/Page53/E1/19.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page53/E1/20.jpg' },
      ],

    ]
  },

  2: {
    unit: 'Unit 7',
    id: 'WB4-V2-U7-P53-E2',
    audio: '',
    video: '',
    component: UI,
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page53/E2/1.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page53/E2/2.jpg' },
      ],
    ]
  },

  3: {
    unit: 'Unit 7',
    id: 'WB4-V2-U7-P53-E3',
    audio: '',
    video: '',
    component: D1,
    titleImage: '',
    hideBtnFooter: true,
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page53/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page53/E3/2.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page53/E3/3.jpg' },
        { url: 'img/FriendsPlus/Page53/E3/4.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page53/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page53/E3/6.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page53/E3/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page53/E3/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page53/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page53/E3/10.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page53/E3/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page53/E3/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page53/E3/13.jpg' },
        { url: 'img/FriendsPlus/Page53/E3/14.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page53/E3/15.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page53/E3/16.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page53/E3/17.jpg' },
        { url: 'img/FriendsPlus/Page53/E3/18.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page53/E3/19.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page53/E3/20.jpg' },
      ],

    ]
  },
}
export default json;